import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@spotahome/ui-library';

const InternalLink = ({ text, hasComma, url = '' }) => (
  <>
    <Link href={url}>{text}</Link>
    {hasComma ? ', ' : null}
  </>
);

InternalLink.propTypes = {
  text: PropTypes.string.isRequired,
  hasComma: PropTypes.bool,
  url: PropTypes.string.isRequired
};

InternalLink.defaultProps = {
  hasComma: null
};

export default InternalLink;
